import * as XLSX from 'xlsx';
import { apiClient } from '../../../api/apiClient';

export async function downloadPayrollTransferExcel({ period, showToast }) {
  if (!period?.id) {
    showToast?.('급여 기간을 먼저 선택하세요.', 'error');
    return;
  }
  if (period.status !== 'confirmed') {
    showToast?.('확정된 급여만 급여이체 엑셀을 다운로드할 수 있습니다.', 'error');
    return;
  }

  try {
    const res = await apiClient.get(`/api/admin/payroll/monthly/periods/${period.id}/transfer-excel`);
    if (!res.data?.success) {
      showToast?.(res.data?.message || '급여이체 엑셀 데이터 조회 실패', 'error');
      return;
    }

    const { fileName, rows = [], missing = [], duplicates = [] } = res.data;
    if (duplicates.length > 0) {
      const names = duplicates.map((item) => `${item.name} ${item.count}건`).join(', ');
      showToast?.(`중복 급여기록은 최신 1건만 포함했습니다: ${names}`, 'warning');
    }
    if (missing.length > 0) {
      const names = missing.map((item) => `${item.name}(${item.reason})`).join(', ');
      showToast?.(`계좌 확인 필요 ${missing.length}명 제외: ${names}`, 'error');
    }
    if (rows.length === 0) {
      showToast?.('다운로드할 데이터가 없습니다.', 'error');
      return;
    }

    const wsData = rows.map((row) => [
      row.bankCode,
      row.accountNumber,
      Number(row.amount),
      row.accountHolder,
      row.senderName,
    ]);
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws['!cols'] = [{ wch: 10 }, { wch: 20 }, { wch: 14 }, { wch: 12 }, { wch: 14 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '급여이체');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
    showToast?.(`${fileName}.xlsx 다운로드 완료`, 'success');
  } catch (_) {
    showToast?.('급여이체 엑셀 다운로드 실패', 'error');
  }
}
